import { isNil, isString, isEmptyString } from '@wistia/type-guards';

const containsEmojiCharacter = (char: string): boolean => {
  // this combines Unicode character class escape - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape
  // with the `Extended_Pictograph` property - https://unicode.org/reports/tr51/
  const emojiRegex = /<a?:.+?:\d{18}>|\p{Extended_Pictographic}/gu;

  return emojiRegex.test(char);
};

export const formatNameForDisplay = (name: string | null | undefined): string => {
  if (isNil(name) || !isString(name) || isEmptyString(name) || containsEmojiCharacter(name)) {
    return 'U'; // fallback initials are `U` for User
  }

  // only display the first character as initial
  const firstChar = name.trim().substring(0, 1);

  // always return an uppercase initial
  return firstChar.toUpperCase();
};
